import React from 'react';
import { sceneOptions } from '../data/vehicleData.js';

const SceneSelector = ({ selectedScene, onSceneChange }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800">Scene Setting</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {sceneOptions.map((scene) => (
          <div
            key={scene.id}
            onClick={() => onSceneChange(scene.id)}
            className={`p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
              selectedScene === scene.id
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 bg-white hover:border-gray-300'
            }`}
          >
            <h4 className="font-medium text-gray-800">{scene.name}</h4>
            <p className="text-sm text-gray-600 mt-1">{scene.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SceneSelector;